import React, { useState, useEffect } from "react";
import { Typography, Tag, Table, TableFooter, Select } from "components";
import {
  capitalizeFirstLetter,
  formatDateTime,
  formatUrlQuery,
  formatFilterPayload,
  truncateString,
} from "utils/helper";
import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/routePaths";
import { BsArrowRight } from "react-icons/bs";
import "./style.scss";

const PendingKYC = () => {
  const navigate = useNavigate();

  const initialFilterState = {
    number: 1,
    onboardState: "FILES_UPLOADED",
    createdDateFrom: "",
    createdDateTo: "",
    size: 10,
    status: "PENDING_CREATION_AUTHORIZATION",
  };

  const [filterState, setFilterState] = useState(initialFilterState);

  const { size, number, status } = filterState;

  const [data, setData] = useState({
    users: null,
    loading: false,
  });

  //   const [openDateModal, setOpenDateModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterState({ ...filterState, [name]: value });
  };

  const getusersData = (queryParams) =>
    makeRequest("get", routes.getAgentPersonalDetails(queryParams));

  const loadUsers = async (
    queryParams = formatUrlQuery(formatFilterPayload(filterState))
  ) => {
    setData({ ...data, loading: true });
    try {
      const res = await getusersData(queryParams);
      setData((prev) => ({
        ...prev,
        users: res.data.data,
        loading: false,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const isPending = filterState.status === "PENDING_CREATION_AUTHORIZATION";

  useEffect(() => {
    loadUsers();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [number, size, status]);

  let columns = [
    {
      Header: "S/N",
      Cell: (row) => Number(row.row.id) + 1,
    },
    {
      Header: "Agent Name",
      Cell: ({ row }) => {
        const { firstName, lastName, agentDetails } = row.original || {};

        if (agentDetails?.corporate) return agentDetails?.corporateName;

        return (
          capitalizeFirstLetter(firstName) +
          " " +
          capitalizeFirstLetter(lastName)
        );
      },
    },
    {
      Header: "Corporate",
      Cell: ({ row }) => (row.original?.agentDetails?.corporate ? "Yes" : "No"),
    },
    {
      Header: "PM Number",
      accessor: "phoneNumber",
    },
    {
      Header: "Username",
      accessor: "username",
    },
    {
      Header: "View Details",
      Cell: ({ row }) => (
        <Typography
          variant="caption1"
          className="cursor-pointer"
          onClick={() => {
            navigate(ROUTES.pendingKYC, {
              state: {
                agentId: row.original?.agentDetails?.agentId,
                comment: row.original?.agentDetails?.kyccomment,
              },
            });
          }}
        >
          View all Details <BsArrowRight />
        </Typography>
      ),
    },
    {
      Header: "KYC Validation",
      Cell: ({ row }) => {
        return row?.original?.agentDetails?.status ===
          "PENDING_CREATION_AUTHORIZATION" ? (
          <Tag
            text={"Pending"}
            backgroundColor={"#FCF6E6"}
            textColor={"#EFB008"}
          />
        ) : (
          <Tag
            text={"Rejected"}
            backgroundColor={"#FCEFEF"}
            textColor={" #DC2C2C"}
          />
        );
      },
    },
    {
      Header: "Date Created",
      Cell: ({ row }) => {
        return formatDateTime(row.original?.agentDetails?.createdDate);
      },
    },
  ];

  if (!isPending) {
    columns.splice(5, 0, {
      Header: "Comment",
      Cell: ({ row }) => truncateString(row.original?.agentDetails?.kyccomment),
    });
  }

  return (
    <div className="dashboard-page-container">
      <div className="approval-table-container">
        <div className="d-flex justify-content-between">
          <Typography
            state="primary"
            component="h4"
            variant="subtitle3"
            className={"mb-2"}
          >
            New Accounts {!isPending ? "Rejected" : "Pending"}
          </Typography>
          <div>
            <Select
              placeholder="Select reason"
              size="sm"
              required={false}
              options={[
                { label: "Pending", value: "PENDING_CREATION_AUTHORIZATION" },
                { label: "Rejected", value: "DISABLED" },
              ]}
              name="status"
              value={!isPending ? "DISABLED" : "PENDING_CREATION_AUTHORIZATION"}
              onChange={handleChange}
            />
          </div>
        </div>

        <Table
          columns={columns}
          data={data.loading ? [] : data.users?.content}
          centerData
          loading={data.loading}
        />
        {data?.users?.content?.length ? (
          <TableFooter
            pageSize={filterState.size}
            handleChange={handleChange}
            availableDataLength={data?.users?.content?.length}
            totalDataLength={data.users.totalElements}
            handlePageClick={(pageNo) =>
              setFilterState({ ...filterState, number: pageNo })
            }
          />
        ) : (
          ""
        )}
      </div>
      {/* <DateFilterModal
        openDateModal={openDateModal}
        setOpenDateModal={setOpenDateModal}
        handleChange={handleChange}
        startDate={createdDateFrom}
        endDate={createdDateTo}
        onButtonClick={() => {
          setOpenDateModal(false);
          loadUsers();
        }}
      /> */}
    </div>
  );
};

export default PendingKYC;
